import React, { useState, useEffect, useCallback } from 'react'
import { getListeProduit, setProduit } from '../actions'
import { connect } from 'react-redux'
import SearchProd from '../components/searchProd'
import FicheProduit from '../components/ficheProduit'
import { useMediaQuery, useTheme } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

const Produit = ({ getListeProduit, setProduit, prodSelected }) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const [searchOpen, setSearchOpen] = useState(true)
    const [lastRef, setLastRef] = useState('')

    useEffect(() => {
        getListeProduit()
    }, [getListeProduit])

    const handleSelect = useCallback((produit) => {
        setLastRef(produit.ref)
        setProduit(produit.id_cv, produit.id_centre)
        if (isMobile) setSearchOpen(false)
    }, [setProduit, isMobile])

    // Desktop : layout classique 2 colonnes
    if (!isMobile) {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-8">
                        <FicheProduit />
                    </div>
                    <div className="col-4">
                        <SearchProd handleSelect={handleSelect} />
                    </div>
                </div>
            </div>
        )
    }

    // Mobile : FicheProduit plein écran + overlay recherche
    return (
        <div style={{ position: 'relative', minHeight: '100vh' }}>
            <FicheProduit mobile onSearchClick={() => setSearchOpen(true)} />

            {/* Overlay recherche plein écran */}
            {searchOpen && (
                <div
                    onClick={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                    style={{
                        position: 'fixed',
                        top: 0, left: 0, right: 0, bottom: 0,
                        backgroundColor: '#fff',
                        zIndex: 1200,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                    }}
                >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '8px 12px',
                        borderBottom: '1px solid #e0e0e0',
                        backgroundColor: '#f5f5f5',
                    }}>
                        <IconButton onClick={() => setSearchOpen(false)}>
                            <CloseIcon />
                        </IconButton>
                        <span style={{ fontSize: 18, fontWeight: 500, marginLeft: 8 }}>Rechercher un produit</span>
                    </div>
                    <div style={{ flex: 1, overflow: 'auto', padding: 12 }}>
                        <SearchProd
                            handleSelect={handleSelect}
                            initialRef={lastRef}
                            fullScreen
                            autoFocus
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        listeProduit: state.produit.listeProduit,
        prodSelected: state.produit.selectedProduct,
    }
}
const mapDispatchToProps = {
    getListeProduit,
    setProduit,
}
export default connect(mapStateToProps, mapDispatchToProps)(Produit)